import styled from 'vue-styled-components'

export const ScheduleControlContent = styled.div`
    & .widget {
        background-color: #FFFFFF;
        padding: 15px;
        border-radius: 5px;
        box-shadow: 0px 1px 1px #cccccc;
        margin-bottom: 15px;
    }
    & .con-vs-alert-danger {
      height: auto !important;
    }
    & .lists-errors {
      margin: 0;
      padding-left: 20px;
      list-style: circle;
      & li {
        margin: 0;
      }
    }
    & .card-header:first-child {
      border-radius: unset !important;
    }
    & .modal-content {
    background-color: transparent;
    }
    & .picker-content {
        display: flex;
        justify-content: center;  
    }
    & .btn-option {
      width: 30px !important;
      height: 30px !important;
    }
`